import VueRouter from "vue-router";
import Vue from "vue";
import WineListIndex from "@/views/winelist/Index";
import WineListCreate from "@/views/winelist/Create";
import WineListEdit from "@/views/winelist/Edit";
import WineListView from "@/views/winelist/View";
import WineListSettings from "@/views/winelist/Settings";

Vue.use(VueRouter);

const routes = [
  {
    path: "/my-lists",
    name: "lists",
    component: WineListIndex,
    meta: {
      title: "Wine Lists"
    }
  },
  {
    path: "/new",
    name: "new-list",
    component: WineListCreate,
    meta: {
      title: "New Wine List"
    }
  },
  {
    path: "/new/:sku",
    name: "new-list",
    component: WineListCreate,
    meta: {
      title: "New Wine List"
    }
  },
  {
    path: "/edit/:id",
    name: "edit-list",
    component: WineListEdit,
    meta: {
      title: "Edit Wine List"
    }
  },
  {
    path: "/edit/:template/:id",
    name: "edit-list",
    component: WineListEdit,
    meta: {
      title: "Edit Wine List"
    }
  },
  {
    path: "/view/:id",
    name: "view-list",
    component: WineListView,
    meta: {
      title: "View Wine List"
    }
  },
  {
    path: "/view/:template/:id",
    name: "view-list",
    component: WineListView,
    meta: {
      title: "View Wine List"
    }
  },
  {
    path: "/settings/:id",
    name: "settings",
    component: WineListSettings,
    meta: {
      title: "Settings"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/wine-list",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Jeroboams";
  next();
});

export default router;
